module.exports = __webpack_public_path__ + "img/0Q3A2626_L_Black_MockedUp.fc269bcd.jpg";